// extracted by mini-css-extract-plugin
export default {"container":"qANAE","text":"AykVZ","textFail":"bWIV3","forceError":"cmEp6","absTooltip":"n1ruH"};